module.exports = __webpack_public_path__ + "img/PT.dd2aa770.svg";